module.exports = __webpack_public_path__ + "static/media/LearnCreatorHero.c5ca00f8.png";